import Vue from 'vue';
import Component from 'vue-class-component';
import Fragment from 'vue-fragment';
import '@gig/magic-message-bus';
import '@gig/magic-ab-test';

// Uncomment for message bus logging
// window.eventBus.enableLogging();
// window.queryBus.enableLogging();
// window.commandBus.enableLogging();

import { magic } from '@gig/magic-sdk';
import {
    links,
    initializeTheme,
    registerTrackingService,
    languageQuery,
} from '@gig/magic-common';
import { TrackingServiceV2 } from '@gig/magic-common/dist/services/tracking/tracking-v2.service';

import { App } from './components/app';
import { config, setHtmlLang } from './services';
import { getRouter } from './routes/router';
import { store } from './store';
import {
    CountryToJurisdiction,
    i18nQuery,
    toolkit,
} from '@gig/magic-frontend-toolkit';
import { Jurisdiction } from '@gig/magic-jurisdictions';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';

const COUNTRY_TO_JURISDICTION: CountryToJurisdiction = {
    [Country.SWEDEN]: Jurisdiction.SGA,
};

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['shady-slot', 'slot', /^magic-/];

// Register the router hooks with their names
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

// If we're running inside Cypress
if ((window as any).Cypress) {
    // Export magic to use in our tests.
    (window as any).magic = magic;
    (window as any).inTestEnvironment = true;

    // Set configuration overrides on page load and expose config for on the fly configuration modification.
    const cyConfiguration = (window as any)._configTransformer;
    if (cyConfiguration) {
        cyConfiguration(config);
    }
}
const defaultJurisdiction = Jurisdiction.MGA;

// Set the initial theme to light or dark;
initializeTheme();

// Register tracking service version for use in this project
const trackingService = new TrackingServiceV2();
registerTrackingService(trackingService);

// Removes the splash screens
function removeSplashScreen() {
    document.body.classList.add('is-loaded');
}

// Uncomment the block of code
// if the PendingQueryTimeoutInMs default value needs to be overridden
/* if (window.inTestEnvironment) {
    // Overrides the PendingQueryTimeoutInMs default value
    // with the new value, provided in milliseconds
    window.queryBus.overridePendingQueryTimeoutInMs(11000);
} */

toolkit
    .bootstrap(config, COUNTRY_TO_JURISDICTION, defaultJurisdiction)
    .then(async () => {
        Vue.use(Fragment.Plugin);

        const [lang, i18n, router] = await Promise.all([
            languageQuery(),
            i18nQuery(),
            getRouter(),
        ]);

        setHtmlLang(lang);
        removeSplashScreen();
        new Vue({
            i18n,
            router,
            store,
            render: (h) => h(App),
        }).$mount('#app');

        links.registerLinkHandler((path) => {
            router.push(path).catch(() => null);
        });
    });
